export const mapDatasetList = [
  {
    id: 1,
    title: "HKH Outline",
    description:
      "Digital line dataset of Outline boundary of Hindu Kush Himalayan (HKH) Region, derived from ESRI Map and Data 2001 and presented at a 1:1 million scale.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Outline/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=3924",
    appURL: "",
  },
  {
    id: 2,
    title: "HKH Major Basin",
    description:
      "The dataset outlines the first-level river basin boundaries of ten major river basins in the Hindu Kush Himalaya (HKH) region, including the Amu Darya, Brahmaputra (Yarlungtsanpo), Ganges, Indus, Irrawaddy, Mekong(Lancang), Salween (Nu), Tarim (Dayan), Yangtse (Jinsha), and Yellow River (Huanghe), as well as two interior river basins.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Basin/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=2732",
    appURL: "",
  },
  {
    id: 3,
    title: "HKH Basin",
    description: "",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Basin/MapServer",
    layerIndex: 1,
    mapServer: "arcgis",
    rdsURL: "",
    appURL: "",
  },
  // {
  //     'id':4,
  //     'title':'HKH Sub-basin',
  //     'description':'The dataset provides second level or sub-basin river boundaries of ten major river basins in the Hindu Kush Himalaya (HKH) region,including the Amu Darya, Brahmaputra (Yarlungtsanpo), Ganges, Indus, Irrawaddy, Mekong(Lancang), Salween (Nu), Tarim (Dayan), Yangtse (Jinsha), and Yellow River (Huanghe), as well as two interior river basins.',
  //     'mapServiceURL':'https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Basin/MapServer',
  //     'layerIndex':2,
  //     'mapServer':'arcgis',
  //     'rdsURL':'https://rds.icimod.org/Home/DataDetail?metadataId=890',
  //     'appURL':''
  // },
  {
    id: 5,
    title: "Mountain Regions",
    description:
      "Digital raster dataset of Mountain regions of the Hindu Kush Himalayan (HKH) region. This dataset is prepared based on GTOPO30 global elevation data and the mountain class definitions - Class 1: elevation > 4500m; Class 2: elevation 3500-4500m; Class 3: elevation 2500-3500m; Class 4: elevation 1500-2500m and slope >= 20; Class 5: elevation 1000-1500 m and slope >= 50 or local elevation range (7 km radius) > 300 m; Class 6: elevation 300-1000m and local elevation range (7 km radius) > 300m.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Physiography/MapServer",
    layerIndex: 4,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=8743",
    appURL: "",
  },
  {
    id: 6,
    title: "Land Cover of HKH 2022",
    description:
      " High-quality land cover data at the regional level for the HKH at 30m resolution.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Landcover/MapServer",
    layerIndex: 21,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=1972511",
    appURL: "",
  },
  {
    id: 7,
    title: "Protected areas in the HKH",
    description:
      "The dataset sourced from protected planet database, represents protected areas in the HKH region.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Environment/MapServer",
    layerIndex: 1,
    mapServer: "arcgis",
    rdsURL: "",
    appURL: "",
  },
  {
    id: 8,
    title: "Glacier in the HKH",
    description:
      "Digital polygon data of Status of Glaciers in Hindu Kush Himalayan (HKH) Region during 2005 ± 3 (2002-2008) years created using Landsat ETM+ imageries of respective years.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Glacier/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=9359",
    appURL: "",
  },
  {
    id: 9,
    title: "Glacial lakes in HKH",
    description: "",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/GlacialLake/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "",
    appURL: "",
  },
  {
    id: 10,
    title: "Population Density 2020",
    description:
      "Digital Grid dataset of Population density estimates in 2010 for HKH region. This dataset is downloaded from the Center for International Earth Science Information Network (CIESIN), Columbia University. It shows the estimates of human population for the year 2010 by 2.5 arc-minute grid cells.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/PopDensity/MapServer",
    layerIndex: 4,
    mapServer: "arcgis",
    rdsURL: "",
    appURL: "",
  },
  // {
  // 'id':11,
  // 'title':'Hydropower Plants in the HKH',
  // 'description':'',
  // 'mapServiceURL':'',
  // 'layerIndex':0,
  // 'rdsURL':'',
  // 'appURL':''
  // },
  {
    id: 12,
    title: "GLOFs in the High Mountain Asia",
    description:
      "First comprehensive inventory of Glacier Lake Outburst Floods (GLOFs) in High Mountain Asia (HMA), documenting 697 events from 1833 to 2022, including their occurrence, formation processes, and downstream impacts.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/GLOF/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=1973283",
    appURL:
      "https://icimod.maps.arcgis.com/apps/dashboards/2a7bb27f727542329c12c3f3da9b5bb8",
  },
  // {
  // 'id':13,
  // 'title':'Perennial Waterbody in the HKH',
  // 'description':'Digital polygon vector layer of perennial rivers and lakes in the Hindu Kush Himalayan (HKH) Region, derived from ESRI Map & Data 2001',
  // 'mapServiceURL':'https://geoapps.icimod.org/arcgisimage/rest/services/Inundation/PerennialWaterbody/ImageServer',
  // 'layerIndex':0,
  // 'rdsURL':'https://rds.icimod.org/Home/DataDetail?metadataId=3009',
  // 'appURL':''
  // },
  {
    id: 14,
    title: "Glaciers of Nepal 2010",
    description:
      "Digital polygon layer of glaciers in Nepal for the year 2010, created using Landsat TM and ETM+ imagery.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/Nepal/GCF/MapServer",
    layerIndex: 28,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=9352",
    appURL: "",
  },
  {
    id: 15,
    title: "Glaciers of Bhutan 2010",
    description:
      "Digital polygon layer of glaciers in Bhutan for the year 2010, created using Landsat TM and ETM+ imagery.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Glacier/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=9347",
    appURL: "",
  },
  {
    id: 16,
    title: "Forest Fires in Nepal",
    description:
      "Moderate Resolution Imaging Spectroradiometer (MODIS)-based active fire incidents in Bhutan from February 2012 to June 2016, overlaid with land cover data to identify forest fire incidents in the country.",
    mapServiceURL:
      "https://geoapps.icimod.org/arcgis/rest/services/Nepal/NepalActiveFire/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=8899",
    appURL: "http://nepal.spatialapps.net/NepalForestFire/EN",
  },
  {
    id: 17,
    title: "Forest Fires in Bhutan",
    description:
      "Moderate Resolution Imaging Spectroradiometer (MODIS)-based active fire incidents in Bhutan from March 2012 to June 2016, overlaid with land cover data to identify forest fire incidents in the country.",
    mapServiceURL:
      "https://geoapps.icimod.org/arcgis/rest/services/Bhutan/BhutanActiveFire/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=28607",
    appURL: "https://geoapps.icimod.org/BhutanForestFire/FireStats/",
  },
  {
    id: 18,
    title: "Hydropower Plants in Nepal (in MW)",
    description:
      "Point data layer of hydropower plants in Nepal, categorized into four types: operational, under construction, and planned. The information was sourced from the Department of Electricity Development, Government of Nepal.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/Nepal/Hydropower/MapServer",
    layerIndex: 0,
    mapServer: "arcgis",
    rdsURL: "",
    appURL:
      "https://icimod.maps.arcgis.com/apps/dashboards/e599934a6b3649f4a5eb1e59c077bf6c",
  },
  // {
  //     'id':19,
  //     'title':'Land Cover in Nepal 2022',
  //     'description':'Annual land cover data of Nepal (2000-2019) created through the National Land Cover Monitoring System (NLCMS) using Landsat remote-sensing data and a cloud-based machine learning architecture on the Google Earth Engine (GEE) platform. ',
  //     'mapServiceURL':'https://geoapps.icimod.org/geoserver/Nepal_LULC/wms',
  //     'layerIndex':'Nepal_LULC:landcover_2022',
  //     'mapServer':'geoserver',
  //     'rdsURL':'https://rds.icimod.org/Home/DataDetail?metadataId=1972729',
  //     'appURL':'http://nepal.spatialapps.net/NLCMS'
  // },
  {
    id: 20,
    title: "Land Cover in Bhutan 2010",
    description:
      "Land cover data of Bhutan for 2010 created using LandSat satellite imagery with a 30-meter spatial resolution.",
    mapServiceURL:
      "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Landcover/MapServer",
    layerIndex: 4,
    mapServer: "arcgis",
    rdsURL: "https://rds.icimod.org/Home/DataDetail?metadataId=8880",
    appURL: "",
  },
];
